module.exports = __webpack_public_path__ + "img/gov-intro-rules-bg.67917931.png";